import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-workspace-dark-switch',
  templateUrl: './workspace-dark-switch.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WorkspaceDarkSwitchComponent {
  @Input() isDarkTheme: boolean;

  @Output() toggled = new EventEmitter();

  toggleDarkTheme(isDark: boolean) {
    this.toggled.emit(isDark);
  }
}
